import React from 'react';
import Select from 'react-select';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SelectOptions } from '../../utils/types/react_select_types';
import { customStyles } from './custom_select_styles';

type CustomSelectProps = {
  label?: string;
  name: string;
  options: SelectOptions[] | undefined;
  value?: SelectOptions | SelectOptions[];
  onChange: any;
  disabled?: boolean;
  clearable?: boolean;
  isMulti?: boolean;
  closeMenuOnSelect?: boolean;
  hideSelectedOptions?: boolean;
  components?: any;
};

export const CheckboxMultiSelect = ({
  label,
  name,
  options,
  value,
  onChange,
  disabled,
  clearable = false,
  isMulti,
  closeMenuOnSelect,
  hideSelectedOptions,
  components,
}: CustomSelectProps) => {
  return (
    <Box sx={{ width: '100%' }}>
      {label && (
        <Typography
          component="label"
          htmlFor={name}
          sx={{
            display: 'block',
            mb: 0.75,
            fontSize: '11px',
            fontWeight: 600,
            color: 'text.secondary',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            ml: 0.25,
          }}
        >
          {label}
        </Typography>
      )}
      <Select
        value={value}
        name={name}
        options={options}
        onChange={onChange}
        styles={customStyles}
        isDisabled={disabled}
        // @ts-ignore
        isMulti={isMulti}
        isClearable={clearable}
        maxMenuHeight={200}
        closeMenuOnSelect={closeMenuOnSelect}
        hideSelectedOptions={hideSelectedOptions}
        components={{ Option: components }}
      />
    </Box>
  );
};
